// extracted by mini-css-extract-plugin
export var enter = "NavOverlay-module--enter--51t0v";
export var enterActive = "NavOverlay-module--enterActive--fqXwO";
export var exit = "NavOverlay-module--exit--JeZYu";
export var exitActive = "NavOverlay-module--exitActive--g05ux";